import { giphyLightGrey, giphyIndigo } from '@giphy/colors'
import { ReactNode } from 'react'
import IconTooltip from 'shared/components/ui/icon-tooltip'
import styled from 'styled-components'

const Container = styled.div`
    right: -16px;
    top: -39px;
    position: absolute;
    color: ${giphyLightGrey};
    padding-top: 3px;
`

const ToolTip = styled.span`
    font-size: 12px;
    position: relative;
    right: 5px;
`

const ToolTipInnerds = styled.div`
    font-weight: normal;
    text-align: center;
    line-height: normal;
    width: 200px;

    p:last-child {
        margin: 0px;
    }
`

const LearnMore = styled.p`
    text-align: center;

    a {
        color: ${giphyIndigo};
        font-weight: bold;
    }
`

const Help = styled.span`
    display: inline-block;
`

const TaggingHelp = ({ children }: { children: ReactNode }) => (
    <Container>
        <Help>Tagging Help</Help>
        <ToolTip>
            <IconTooltip icon={'ss-help'} color={giphyLightGrey}>
                <ToolTipInnerds>
                    <p>{children}</p>
                    {
                        <LearnMore>
                            <a
                                href="https://support.giphy.com/hc/en-us/articles/4405176151834-Content-Tagging-Guidelines"
                                target="_blank"
                                rel="noreferrer"
                            >
                                Learn More
                            </a>
                        </LearnMore>
                    }
                </ToolTipInnerds>
            </IconTooltip>
        </ToolTip>
    </Container>
)

export default TaggingHelp
